import DropdownControl from '../dropdown/DropdownControl'
import ButtonControl from '../button-control'
import AppliedFilter from './AppliedFilter'

function normalizeCategories (categories, onFilterChange) {
  return categories
    .filter(parent => parent.categories)
    .map(parent => {
      return {
        groupName: parent.groupName,
        items: parent.categories.map(child => {
          return {
            title: child.categoryName,
            value: child.categoryId,
            onClick: onFilterChange
          }
        })
      }
    })
}

const CategorySelector = ({ items, selected, onFilterChange }) => {
  items = normalizeCategories(items, onFilterChange)
  return <DropdownControl
    isGrouped
    align={'adjust'}
    trigger={<ButtonControl title={selected ? <AppliedFilter type='category' name={selected.name} /> : 'Filter by category'} class={'filter qa-category-filter'} icon={'arrowDropdown'} />}
    items={items}
  />
}

export default CategorySelector
